/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
  query QueueRead($ownerType: QueueOwnerType, $take: PositiveInt, $skip: Int) {
    QueueRead(ownerType: $ownerType, take: $take, skip: $skip) {
      status
      message
      totalCount
      queues {
        vhost
        name
        trunk
        ownerType
        durable
        autoDelete
        messages
        consumers
      }
    }
  }
`
